module.exports = __webpack_public_path__ + "img/loadState.b2fbbcdc.svg";